import { useEffect } from "react";
import { useSearchParams } from "react-router";

import i18n, { initI18n } from "../i18n/config";
import { useGeneralStore } from "../store/general/general-store";
import { DEFAULT_TIMEZONE } from "../utils/constants";
import { Language } from "../utils/enums";

export function useGeneralConfiguration() {
  // get the l parameter from the url
  const [searchParams] = useSearchParams();
  const languageParam = searchParams.get("l");

  const { language, setLanguage, setCurrentTimezone } = useGeneralStore();

  useEffect(() => {
    if (language !== (i18n.resolvedLanguage as Language)) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  useEffect(() => {
    // making sure i18n is initialized before setting the language and timezone
    initI18n().then(() => {
      // Check if the language parameter from URL is valid, otherwise fallback to i18n resolved language
      const validLanguageParam = languageParam && Object.values(Language).includes(languageParam as Language)
        ? (languageParam as Language)
        : (i18n.resolvedLanguage as Language);
      setLanguage(validLanguageParam);
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      setCurrentTimezone(timeZone ?? DEFAULT_TIMEZONE);
    });
  }, []);
}
